<template>
    <div>
        <loading v-if="isloading" />
        <div class="popmask-container" v-if="isShowPopmask && !isToDownLoad" @click="closePopmask">
            <img :src="maskImg" alt="" />
        </div>
        <div v-if="wxbtnshow" :class="isPop?'btn-position':''" class="wxOpenLaunch-position">
            <wx-open-launch-app id="launch-btn" :extinfo="JSON.stringify(extiData)" :appid="appid" style="width:153px; height:54px;">
                <script type="text/wxtag-template">
                <div style="width: 100%; height: 70px; opacity: 1; background: #d31d4a;">App内查看</div>
                </script>
            </wx-open-launch-app>
        </div>
        <div v-if="from !== 'store' && isPop" class="pop">
            <div class="mid">
                <p>可能离开微信，打开第三方应用</p>
                <div class="btn-div">
                <div class="btns" @click="closePop">取消</div>
                <div class="btns" @click="closePop">继续</div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
    import BsUtil from '../BsUtil'
    import BsGetEnv  from '../BsGetEnv'
    import { getInfo } from './main'
    import loading from './components/loading.vue'
    import axios from 'axios'
    import { configWXSignature } from '../BsWxsdk'

    const showid = BsUtil.queryString('id') || ''

    // 乘客和车主渠都用 channel
    let channel = BsUtil.queryString('channel') || '';
    const URL = BsUtil.queryString('u') || null
    const jump = URL ? 'didapinche://' + URL : 'didapinche://home'
    // const WX_APPID_ONLINE = 'wxf18a88f56d23da94'; // 嘀嗒出行官方号
    // app 下载器
    let appDownload
    const pageShow = window.location.href

    const cid = BsUtil.queryString('cid') || ''
    const rid = BsUtil.queryString('rid') || ''
    let source = BsUtil.queryString('source') || BsUtil.queryString('s') || ''
    const type = BsUtil.queryString('type') || ''
    const from = BsUtil.queryString('from') || ''
    const scheme = BsUtil.queryString('schema') || BsUtil.queryString('scheme') || '' // DIDA-49233从微信H5里跳转App支持打开指定页面
    const fromType = BsUtil.queryString('fromType') || ''
    const yyb = BsUtil.queryString('yyb') || '' // 微信环境下明文访问需要在链接后拼上 yyb 参数，走应用宝下载

    // 乘客包允许的渠道
    const channelList = ['ch608', 'ch609', 'ch610', 'ch163', 'ch164', 'ch165', 'ch166', 'ch167', 'ch168', 'ch169', 'ch170', 'ch171', 'ch172', 'ch604', 'ch611']
  
    // 二次进入该页面时如果参数上有store则直接去 app store
    if (from === 'store' && !BsGetEnv.isAndroid) {
        setTimeout(function() {
            if (yyb === 'true' && BsGetEnv.inWechat) { // 微信环境下明文访问需要在链接后拼上yingyongbao参数，走应用宝下载，其他情况正常走app store
                window.location = '//a.app.qq.com/o/simple.jsp?pkgname=com.didapinche.booking&android_schema=' + encodeURIComponent(jump) + '&ios_scheme=' + encodeURIComponent(jump)
            } else {
                window.location.replace('itms-appss://apps.apple.com/app/apple-store/id921478733')
            }
        }, 300)
    }

    export default {
      name: 'vnBsToApp',
      components: {
        loading
      },
      props: {
        // 引导浏览器图片
        maskImg: {
            type: String,
            default: 'https://web-static.didachuxing.com/pics/g/b4h80wmy5n8.png'
        },
        // 是否是用户点击触发
        isClick: {
            type: Boolean,
            default: BsUtil.queryString('isClick') === 'true' || false,
        },
        // 需要用打开APP指定页面
        urlSchemeParams: {
            type: String,
            default: ''
        },
        // 如果是Hermes用
        isFromHermes: {
            type: Boolean,
            default: false,
        },
        // universal link未唤起时的下载中转页链接
        uLTargetUrl: {
            type: String,
            // default: 'http://10.10.90.52:8080/web-invite-orders/takeorder/?rid=1pSH3ECJmyU&roletype=1&flag=1&source=wxmsg'
            default: 'https://web.didachuxing.com/web-10ce02m/'
        },
        // 为了AB TEST 做渠道区分，优先取链接上的，再取参数传过来的
        propChannel: {
            type: String,
            default: ''
        },
        // hermes web-download-btn 组件传入的$bus方法
        setPageBg: {
            type: Function,
            default: ()=>{}
        },
        // 安卓是否下载车主包  优先取链接上的，再取参数传过来的
        toDriver: {
            type: Boolean,
            default: false,
        },
        // 跳转统一下载页面
        isToDownLoad: {
            type: Boolean,
            default: false,
        }
     },
      data() {
        return {
          isShowPopmask: false,
          isloading: false,
          wxbtnshow: false,
          appid: 'wxd3a1541d4423bf8f',
          extiData: {
            'type': 'wxWakeUp',
            'value': pageShow
          },
          wxerror: false,
          isPop: false,
          from
        }
      },
      computed: {
        // base64转码后的scheme链接 IOS universal link中需要使用
        schemeUrl() {
            return this.isBase64(this.urlSchemeParams) ? this.urlSchemeParams : btoa(this.urlSchemeParams)
        },

    
      },
      watch:{
        // 项目唤起app失败之后，跳转下载页面，适用场景：项目下载按钮处在二级页面时使用
        isShowPopmask: {
            handler(val) {
                if(val && this.isToDownLoad){
                    location.href = `https://www.didapinche.com/toapp/index.html?isClick=true&scheme=${this.schemeUrl}`
                }
            },
            immediate: true,
            deep: true
        },
      },
      mounted(){
        // 如果链接上拼了 id 参数安卓浏览器中通过接口拿渠道包  如 id:370EA2C635043214
        if (showid) {
            this.getShowInfo()
        }
        // 二次进入该页面时如果参数上有store则弹起去 app store
        if(from !== 'store') {
            this.downloadApp()
        } else { // 如果是作为中转页进入的，假如用户点了取消，那么再次点击下载时，应继续弹出去 APP store
            if(this.isClick) {
                window.location.replace('itms-appss://apps.apple.com/app/apple-store/id921478733')
            }
        }
        
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                this.isloading = false
                clearTimeout(appDownload)
                clearTimeout(this.loadingTime)
            } else {
                // 安卓微信环境不需要触发刷新
                if(!(BsGetEnv.inWechat && BsGetEnv.isAndroid)) {
                    window.location.href = pageShow
                }
            }
        })
      },
      methods: {
        // 下载或唤起APP   isClick 是否是用户主动点击
        downloadApp() {
            // alert(33333)
            source = source || this.propChannel
            const that = this
            if (BsGetEnv.inApplication) { // APP环境
                window.location = URL ? 'didapinche://' + URL : this.urlSchemeParams ? this.urlSchemeParams : 'didapinche://home';
            } else {
                if (BsGetEnv.inWechat || this.isDingTalk()) { // 微信环境
                    if (BsGetEnv.inWechat && (BsGetEnv.isAndroid || BsGetEnv.isHarmony)) { //微信开放标签只在微信环境, 只在安卓和鸿蒙使用 且 只有https://www.didapinche.com/toapp/index.html域名可以使用
                      if (location.href.includes('www.didapinche.com')) {
                        this.isPop = true
                        this.extiData.value = pageShow.indexOf('?') !== -1 ? `${pageShow}&source=${source}` : `${pageShow}?source=${source}`
                        configWXSignature([], 'wxf18a88f56d23da94', ['wx-open-launch-weapp', 'wx-open-launch-app'])
                        wx.error((res) => {
                          this.wxerror = true
                          this.wxbtnshow = false
                          console.log('wx.error未加载微信开放标签DOM', res.errMsg)
                        })
                        wx.ready(() => {
                          console.log('start download')
                          // 安卓微信版本号大于 7.0.12 开放标签才可进行 唤醒 app 跳转
                          // eslint-disable-next-line
                          let wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
                          const wxVersion = wechatInfo[1] // 获取微信版本号
                          console.log('wxVersion', wxVersion)
                          if (wxVersion && !this.wxerror) {
                            if (BsGetEnv.isAndroid && BsUtil.compareVersion(wxVersion, '7.0.12') < 0) {
                              this.wxbtnshow = false
                            } else {
                              console.log('start wxbtnshow')
                              this.wxbtnshow = true
                              const that = this
                              this.$nextTick(() => {
                                const launchapp = document.getElementById('launch-btn')
                                if (launchapp) {
                                  launchapp.addEventListener('ready', () => {
                                    console.log('ready')
                                    // 数据是传递给 app 的参数进，
                                  })
                                  launchapp.addEventListener('launch', () => {
                                    // 数据是传递给 app 的参数进，
                                    console.log('success')
                                    that.isPop = false
                                  })
                                  launchapp.addEventListener('error', (e) => {
                                    console.log('fail', e.detail)
                                    that.isPop = false

                                    this.isShowPopmask = true // 唤起失败，引导去浏览器

                                    // 唤醒失败的情况下，可用于降级处理比如在此处跳转到应用宝
                                    // setTimeout(function() {
                                    //   window.location = '//a.app.qq.com/o/simple.jsp?pkgname=com.didapinche.booking&android_schema=' + encodeURIComponent(jump) + '&ios_scheme=' + encodeURIComponent(jump)
                                    // }, 1000)
                                  })
                                }
                              })
                            }
                          }
                        })
                      } else {
                        this.isShowPopmask = true // 唤起失败，引导去浏览器
                      }
                    } else if (BsGetEnv.isAndroid) {
                        // 如果是安卓钉钉环境，需要用户主动点击，引导去浏览器
                        this.isClick && (this.isShowPopmask = true)
                    } else if (BsGetEnv.isiPhone){ // 微信IOS走 universal link
                        if (source === 'zdqd') { // 自动抢单
                            window.location.href = `https://app-tools.didapinche.com/?cid=${cid}&rid=${rid}&source=${source}&type=${type}&from=store`
                        } else {
                            this.universalLinkCfg();
                        }
                    } else {
                        window.location = '//www.didapinche.com/'
                    }
                } else { // 非微信非APP环境（浏览器或其他）环境  渠道包只能在非微信环境下使用
                    if (BsGetEnv.isAndroid) {
                        if (!fromType || this.isClick) { // 安卓浏览器环境，有fromType参数，则让用户手动触发，不自动执行
                          // 直接打开指定页面
                          if(this.urlSchemeParams) {
                              // 安卓浏览器环境直接走 url scheme 不需要base64编码
                              window.location = this.urlSchemeParams
                          } else {
                              if (URL) {
                                  window.location = 'didapinche://' + URL
                              } else if (scheme) {
                                  const urlSchema = this.isBase64(scheme) ? atob(scheme) : scheme
                                  window.location = urlSchema.indexOf('?') !== -1 ? `${urlSchema}&cid=${cid}&source=${source}&fromType=${fromType}` : `${urlSchema}?cid=${cid}&source=${source}&fromType=${fromType}`
                              } else {
                                  window.location = `didapinche://home?cid=${cid}&source=${source}&fromType=${fromType}`
                              }
                          }
                          this.isloading = true
                          this.loadingTime = setTimeout(()=> {
                              this.isloading = false
                          },2500)
                          // 3s 后没打开，直接弹起下载apk弹窗
                          appDownload = setTimeout(() => {
                              this.isloading = false
                              // 弹出Android下载apk
                              that.downloadAndroidApk()
                          }, 3000)
                        }
                    } else if (BsGetEnv.isHarmony) {
                        if (!fromType || this.isClick) { // 鸿蒙浏览器环境，如果有fromType参数，则让用户手动触发，不自动执行
                          // 直接打开指定页面
                          if(this.urlSchemeParams) {
                              // 安卓浏览器环境直接走 url scheme 不需要base64编码
                              window.location = this.urlSchemeParams
                          } else {
                              if (URL) {
                                  window.location = 'didapinche://' + URL
                              } else if (scheme) {
                                  const urlSchema = this.isBase64(scheme) ? atob(scheme) : scheme
                                  window.location = urlSchema.indexOf('?') !== -1 ? `${urlSchema}&cid=${cid}&source=${source}&fromType=${fromType}` : `${urlSchema}?cid=${cid}&source=${source}&fromType=${fromType}`
                              } else {
                                  window.location = `didapinche://home?cid=${cid}&source=${source}&fromType=${fromType}`
                              }
                          }
                          this.isloading = true
                          this.loadingTime = setTimeout(()=> {
                              this.isloading = false
                          },2500)
                          // 3s 后没打开，直接弹起下载apk弹窗
                          appDownload = setTimeout(() => {
                              this.isloading = false
                              // 跳转鸿蒙应用市场
                              window.location = 'https://appgallery.huawei.com/app/detail?id=com.didapinche.passenger'
                          }, 3000)
                        }
                    } else if (BsGetEnv.isiPhone) {
                        if (source === 'zdqd') { // 使用 universal link
                            window.location.href = `https://app-tools.didapinche.com/?cid=${cid}&rid=${rid}&source=${source}&from=store`
                        } else {
                            // 如果有渠道包，则先通过渠道包下载，否则仍然使用 universal link
                            if (channel && channelList.includes(channel)) {
                                window.location = `//web.didachuxing.com/web/baseh5/php/getApp?c=${channel}&t.apk`
                            } else {
                                this.universalLinkCfg();
                            }
                        }
                    } else {
                        if(!this.isFromHermes) window.location = '//www.didapinche.com/'
                    }
                }
            }
        },
        // 安卓非微信环境下载
        async downloadAndroidApk() {
            if (showid && this.status === 'online') { // 有渠道包id的跳转,并且是在线的
                if (this.androidChannelUrl) {
                    window.location = this.androidChannelUrl
                }
            } else {
                // toDriver 标识是车主包  优先取链接上的，再取参数传过来的
                const isDrAPP = BsUtil.queryString('toDriver') === 'true' || this.toDriver
                // 下载车主包
                if (isDrAPP) {
                    const drChannel = channel || 'official'
                    try {
                        const { data } = await axios.get('https://capis-1.didapinche.com/publish/api/dl_version?os=Android&app=CarDriver')
                        const version_id = data.version
                        if (!version_id === '') {
                            return '升级服务异常，请稍后重试！'
                        }
                        const url = `https://apk.didapinche.com/get-apk/driver/${drChannel}/${version_id}`
                        location.replace(url)
                    } catch (e) {
                        console.warn(e)
                    }
                } else if (channel && channelList.includes(channel)) { // 下载乘客包  优先取链接上的，再取参数传过来的
                    window.location = `//web.didachuxing.com/web/baseh5/php/getApp?c=${channel}&t.apk`
                } else if (this.propChannel) {
                    window.location = `//web.didachuxing.com/web/baseh5/php/getApp?c=${this.propChannel}&t.apk`
                } else {
                    window.location = '//web.didachuxing.com/web/baseh5/php/getApp'
                }
            }
        },

        // 通过链接上拼的id 获取对应 渠道包下载链接
        async getShowInfo() {
            try {
                let res = await getInfo({ id: showid })
                // console.log('res',res)
                if (res.code === 0) {
                    this.status = res.ret.status
                    this.androidChannelUrl = res.ret.androidChannelUrl
                    const bgPic = res.ret?.backgroundPicture 
                    const buttonIconUrl = res.ret?.buttonIconUrl 
                    document.title = res.ret?.title || '嘀嗒出行·下载页'
                    
                    bgPic && buttonIconUrl && this.setPageBg({bgPic, buttonIconUrl})

                    if (this.status === 'offline') {
                        this.$didafe.toast('当前下载链接已过期')
                    }
                    if (this.status === 'new') {
                        this.$didafe.toast('当前下载链接未上线')
                    }
                } else {
                    if (res.message.length > 16) {
                        this.$didafe.toast(res.message, { wordWrap: true })
                    } else {
                        this.$didafe.toast(res.message)
                    }
                }
            } catch (e) {
                console.error(e)
            }
        },

        // universalLink跳转
        universalLinkCfg() {
            source = source || this.propChannel
            const res = this.getDominParam(this.uLTargetUrl);
            const targetUrl = res.domin
            const oriParams = res.params
            // 如果有传入的跳转指定页面scheme，那么取base64编码后的，否则取页面链接上参数的 scheme
            const queryScheme = this.isBase64(scheme) ? scheme : btoa(scheme)
            const getScheme = this.urlSchemeParams ? this.schemeUrl : queryScheme
            let uniLink = `https://app-tools.didapinche.com/?cid=${cid}&scheme=${getScheme}&source=${source}&fromType=${fromType}&from=store&targetUrl=${targetUrl}`
            window.location.href = oriParams ? `${uniLink}&${oriParams}` : `${uniLink}`
        },

        // 是否是base64编码
        isBase64(str){
            if(str === '' || str.trim() === ''){
                return false;
            }
            try{
                return btoa(atob(str)) == str;
            }catch(err){
                return false;
            }
        },

        // 获取链接 domin 和 params
        getDominParam(url) {
            // 判断URL中是否包含参数
            let res = {}
            if (url.indexOf('?') !== -1) {
                // 将URL按照'?'进行切割，得到参数部分和其他部分
                const parts = url.split('?');
                res.domin = parts[0]
                res.params = parts[1]
            } else {
                res.domin = url
                res.params = ''
            }
            return res
        },

        // 判断是否是钉钉环境
        isDingTalk() {
            let _userAgent = navigator.userAgent
            if (/DingTalk/gi.test(_userAgent)) { // 判断是否是钉钉客户端
                return true
            } else {
                return false
            }
        },

        closePop() {
            this.isPop = false
        },
        closePopmask() {
          this.isShowPopmask = false
        }
      }
    }
  </script>
  
  <style lang="scss" scoped>
  .popmask-container {
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: hidden !important;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(0,0,0,0.7) !important;
    img {
      right: 8px;
      // top: 13px;
      position: absolute;
    //   width: 261px;
      width: 375px;
    //   height: 117px;
    }
  }
  .pop {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.3);
    overflow: hidden;
  }
  .mid {
    width: 307px;
    height: 153px;
    background: #ffffff;
    border-radius: 6px;
    margin: 205px auto 0;
    p {
      height: 98px;
      line-height: 98px;
      text-align: center;
      font-size: 15px;
      position: relative;
      border-bottom: 1px solid #f2f2f2;
    }
  }
  .btn-div {
    .btns {
      float: left;
      width: 50%;
      text-align: center;
      line-height: 54px;
      font-size: 18px;
    }
    .btns:nth-child(1) {
      border-right: 1px solid #f2f2f2;
    }
    .btns:nth-child(2) {
      color: #566a94;
      position: relative;
    }
  }
  .wxOpenLaunch-position{
    // width: 100%;
    // height: 10vh;
    width: 0;
    height: 0;
    position: fixed;
    top: 670px;
    left: 0;
    opacity: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
  }
  .btn-position {
    width: 153px;
    height: 54px;
    // height: 9vh;
    position: fixed;
    top: 303px;
    left: 187px;
    z-index: 201;
  }
  </style>
  